import React, { useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import api from 'api';
import PopNotificationWithUndo from 'components/PopNotificationWithUndo';
import useCallbackAsync from 'hooks/useCallbackAsync';
import useUndoActions from 'hooks/useUndoActions';
import { GeneralSuggestedActionType } from 'models/SuggestedActions';
import { refetchGeneralSuggestedActions } from '../utils';

export type GeneralSuggestedActionUndoHandlers = {
  setMutedActionType: (type: GeneralSuggestedActionType) => void;
  setMuteUndoTimeout: () => void;
};

const useGeneralUndoActions = () => {
  const [mutedActionType, setMutedActionType] =
    useState<GeneralSuggestedActionType>();

  const {
    isUndoAvailable,
    setUndoTimeout: setMuteUndoTimeout,
    clearUndoTimeout,
  } = useUndoActions();

  const queryClient = useQueryClient();
  const { t } = useTranslation();

  const [onUndoMute, isRestoring] = useCallbackAsync(async () => {
    if (mutedActionType) {
      await api.userSuggestedActions.restoreGeneralSuggestedAction(
        mutedActionType,
      );
    }

    await refetchGeneralSuggestedActions(queryClient);
    clearUndoTimeout();
  });

  const undoNotifications = (
    <PopNotificationWithUndo
      isUndoAvailable={isUndoAvailable}
      disabled={isRestoring}
      onUndo={onUndoMute}
    >
      <p>{t('youWontBeReminded')}</p>
    </PopNotificationWithUndo>
  );

  return {
    undoNotifications,
    setMutedActionType,
    setMuteUndoTimeout,
  };
};

export default useGeneralUndoActions;
